module.exports = __webpack_public_path__ + "img/download.97e3ffdf.svg";